var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H2.08305L8.22666 3.85639L6.14361 1.77334L0 7.91695V10ZM1.11096 8.378L6.14361 3.34535L6.65465 3.85639L1.622 8.88904H1.11096V8.378ZM8.53773 0.162447C8.48634 0.110952 8.4253 0.0700976 8.3581 0.0422228C8.2909 0.014348 8.21887 0 8.14612 0C8.07337 0 8.00133 0.014348 7.93413 0.0422228C7.86693 0.0700976 7.80589 0.110952 7.7545 0.162447L6.73797 1.17898L8.82102 3.26203L9.83755 2.2455C9.88905 2.19411 9.9299 2.13307 9.95778 2.06587C9.98565 1.99867 10 1.92663 10 1.85388C10 1.78113 9.98565 1.7091 9.95778 1.6419C9.9299 1.5747 9.88905 1.51366 9.83755 1.46227L8.53773 0.162447Z",
    fill: "#FDFAF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cb25aa56d092b42e7ddb097b3886b1fd.svg";
export { ForwardRef as ReactComponent };